export default __webpack_public_path__ + "static/media/atom-i-link-green.531c646c.svg";